import { render, staticRenderFns } from "./Calendario.vue?vue&type=template&id=4ea38c99&"
import script from "./Calendario.vue?vue&type=script&lang=ts&"
export * from "./Calendario.vue?vue&type=script&lang=ts&"
import style0 from "./Calendario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAlert,VMain})
